import classNames from 'classnames';

const ExclamationTriangleIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const { className = '', ...attributes } = props;
  const classes = classNames('exclamation-triangle-icon', className);

  return (
    <svg
      width="36"
      height="32"
      viewBox="0 0 36 32"
      className={classes}
      {...attributes}
    >
      <path d="M15.547 12.794c-0.025-0.431 0.317-0.794 0.749-0.794h3.409c0.431 0 0.774 0.363 0.749 0.794l-0.412 7c-0.023 0.39-0.358 0.706-0.749 0.706h-2.586c-0.397 0-0.725-0.309-0.749-0.706zM20.625 24c0 1.45-1.175 2.625-2.625 2.625s-2.625-1.175-2.625-2.625 1.175-2.625 2.625-2.625 2.625 1.175 2.625 2.625zM20.599 1.499l14.996 26.002c1.154 2-0.294 4.499-2.599 4.499h-29.993c-2.308 0-3.75-2.503-2.599-4.499l14.997-26.002c1.154-2.001 4.045-1.997 5.197 0zM3.324 28.438c-0.144 0.25 0.036 0.562 0.325 0.562h28.702c0.289 0 0.469-0.312 0.325-0.562l-14.351-24.875c-0.144-0.25-0.505-0.25-0.65 0z"></path>
    </svg>
  );
};

export default ExclamationTriangleIcon;
